export const Day2Common = {
    applicationCI: 'api/app-registrations/3.0/all-app-profiles',
    costCenter: 'api/cmdb/lookups/1.0/projects',
    businessAppOwner: 'api/order/snow/1.0/{businessApplicationName}/it-owner',
    appShortName: 'api/ri/resource/name/1.0/app-short-name',
    appShortNameValidation: 'api/ri/resource/name/1.0/app-short-name/availability',
};
export default Day2Common;
